<!--
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-04-04 19:29:28
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-05-09 11:41:56
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\components\element\radio.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script lang="jsx">
export default {
  name: 'ERadio',
  props: {
    options: {
      //选项列表
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    return () => (
      <el-radio-group>
        {props.options.map((e) => (
          <el-radio label={e.value}>{e.label}</el-radio>
        ))}
      </el-radio-group>
    );
  },
};
</script>
